(function () {
  const FAVORITES_KEY = "hm:product_favorites";
  const favoriteBtns = Array.from(document.querySelectorAll(".favorite"));
  const favoriteGridItems = Array.from(
    document.querySelectorAll(
      ".favorites-grid--local .product-grid .grid__item"
    )
  );

  const favoritesMsg = document.querySelector(".no-favorites-message");

  let activeFavorites = getLocalStorageFavorites();

  function getLocalStorageFavorites() {
    let localFavorites = [];
    try {
      const currentLocalStorageFavorites =
        window.localStorage.getItem(FAVORITES_KEY);
      if (currentLocalStorageFavorites) {
        localFavorites = JSON.parse(currentLocalStorageFavorites);
      } else {
        window.localStorage.setItem(FAVORITES_KEY, JSON.stringify([]));
      }
    } catch (e) {
      console.error(e);
    }
    return localFavorites;
  }

  function updateLocalStorageFavorites(productId) {
    let currentLocalFavorites = getLocalStorageFavorites();
    let favoritesArrAsSet = new Set(currentLocalFavorites);
    // If the item is already in the array remove it otherwise add it.
    if (favoritesArrAsSet.has(productId)) {
      favoritesArrAsSet.delete(productId);
    } else {
      favoritesArrAsSet.add(productId);
    }
    window.localStorage.setItem(
      FAVORITES_KEY,
      JSON.stringify(Array.from(favoritesArrAsSet))
    );
    activeFavorites = getLocalStorageFavorites(); // update localFavorites
    updateFavoriteStatus();
  }

  function updateFavoriteStatus() {
    favoriteBtns.forEach((btn) => {
      const productId = btn.dataset.productId;
      if (activeFavorites.includes(productId)) {
        btn.setAttribute("data-favorited", true);
      } else {
        btn.setAttribute("data-favorited", false);
      }
    });
  }

  // Attach event handlers.
  favoriteBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      const productId = btn.dataset.productId;
      updateLocalStorageFavorites(productId);
    });
  });

  activeFavorites.forEach((favorite_id) => {
    favoriteGridItems.forEach((product) => {
      const product_id = product.dataset.productId;
      if (product_id === favorite_id) {
        product.classList.add("active");
      }
    });
  });

  updateFavoriteStatus();

  // Toggle no favorites message.
  if (favoritesMsg && activeFavorites.length === 0) {
    favoritesMsg.style.display = "block";
  } else if (favoritesMsg && activeFavorites.length > 0) {
    favoritesMsg.style.display = "none";
  }
})();
